import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import * as PIXI from "pixi.js";
import Facade from "../Facade";
import SpineRepeatedAnimation from "@base/spineAnimation/SpineRepeatedAnimation";
import Tweenlite from "gsap";
import gsap from "gsap";
import Config from "@/config/Config";
import AddComponent from "@base/utils/AddComponent";
import ParticlesAnimationContainer from "@/containers/ParticlesAnimationContainer";
import WinNumbersContainer from "@/containers/WinNumbersContainer";

export default class BigWinContainer extends BaseContainer {
    constructor(data) {
        super(data);
        this.state = "initBigWin";
        this.init();
    }

    init(data) {
        Signals.startCountingUpWinnings.add(this.onShowBigWin, this);
        Signals.orientationChanged.add(this.onOrientationChanged, this);
        //  Signals.showBigWin.add(this.enableBigWin, this);

        this.containerBigWin = AddComponent.addContainer(this);

        this.shadow = new PIXI.Graphics();
        this.shadow.beginFill(0x000000, 0.8);
        this.shadow.drawRect(-2000, -2000, 5000, 5000);
        this.shadow.endFill();

        this.containerBigWin.addChild(this.shadow);
        this.shadow.interactive = true;
        this.shadow.on("pointerdown", this.skip, this);

        this.particlesAnimationContainer = new ParticlesAnimationContainer();
        this.containerBigWin.addChild(this.particlesAnimationContainer);

        const reelsPattern = Config.pattern.reels;
        AddComponent.addSpineAnimationPlay("big_win_elements", "message_bg_ani", this.containerBigWin, [reelsPattern.x + 200, reelsPattern.y + 600]);

        this.bigWin = new SpineRepeatedAnimation("big_win_message", this.onCompleteWinAnimation.bind(this), this.onEndWinAnimation.bind(this));
        this.bigWin.x = reelsPattern.x + 480;
        this.bigWin.y = reelsPattern.y + 610;
        this.containerBigWin.addChild(this.bigWin);

        this.winNumbersContainer = new WinNumbersContainer()
        this.winNumbersContainer.y = this.bigWin.y
        this.winNumbersContainer.x = this.bigWin.x - 70;
        this.containerBigWin.addChild(this.winNumbersContainer)

        this.containerBigWin.alpha = 0;
        this.containerBigWin.visible = false;
        this.currentWin = 0;
        this.targetWin = 0;

        this.timeScale = 0.16;
    }

    onShowBigWin() {

        if (!Facade.model.bigWin) {
            return
        }
        this.state = "showBigWin";
        this.skipCount = false;
        this.animationBigWin(Facade.model.bigWin.name)
        Signals.showingBigWin.dispatch();
    }

    animationBigWin(nameBigWin) {
        switch ( nameBigWin ) {
            case "big":
                this.targetWin = 0;
                this.wins = this.createObjAnimation(0);
                this.particlesAnimationContainer.start({quantity: 4000});
                break;

            case "great":
                this.targetWin = 1;
                this.wins = this.createObjAnimation(1);
                this.particlesAnimationContainer.start({quantity: 5000});
                break;

            case "huge":
                this.targetWin = 2;
                this.wins = this.createObjAnimation(2);
                this.particlesAnimationContainer.start({quantity: 6000});
                break;

            case "massive":
                this.targetWin = 3;
                this.wins = this.createObjAnimation(3);
                this.particlesAnimationContainer.start({quantity: 7000});
                break;

            case "jackpot":
                this.targetWin = 4;
                this.wins = this.createObjAnimation(4);
                this.particlesAnimationContainer.start({quantity: 12000});
                break;
        }

        this.bigWin.start(this.wins[this.currentWin].animations, this.wins[this.currentWin].count, this.timeScale,);
        this.containerBigWin.visible = true;
        gsap.to(this.containerBigWin, {duration: 1, alpha: 1, ease: "back.inOut(0.4)"});
    }

    enableBigWin() {
        this.state = "showBigWin";
        Signals.showingBigWin.dispatch();
       // Signals.muteMusic.dispatch();
        //Facade.soundManager.play("win_big_intro", 1, true, "default");
        this.bigWin.visible = true;
    }

    onCompleteWinAnimation() {
        // this.particlesAnimationContainer.cleanup();
    }

    onEndWinAnimation() {
        if (this.currentWin + 1 <= this.targetWin) {
            this.currentWin++;
            // if (this.currName) {
            //   Facade.soundManager.stop(this.currName);
            // }
            // this.currName = `win_big_loop${this.currentWin + 1}`;
            //Facade.soundManager.play(this.currName, 1, true, "default");
            Signals.showBigWinStateChange.dispatch();
            this.bigWin.start(this.wins[this.currentWin].animations, this.wins[this.currentWin].count, this.timeScale,);
        } else {
            this.reset();
            this.containerBigWin.alpha = 0;
            this.containerBigWin.visible = false;
            this.currentWin = 0;
            this.targetWin = 0;
            this.onComplete();
        }

    }

    reset() {
        this.bigWin.stop();
    }

    createObjAnimation(level) {
        let animations = [];
        let anims = [];
        for (let index = 0; index <= level; index++) {
            Config.bigwinStateSuffix.forEach((element) => {
                anims.push(Config.bigwinStatePrefix[index] + element);
            });

            animations.push({
                animations: anims, count: [1, 1],
            });
            anims = [];
        }
        this.bigOut = {
            animations: [Config.bigwinStatePrefix[level] + Config.bigwinStateSuffix[1],], count: [1],
        };
        return animations;
    }

    skip() {
        //PROBABLY SHOULD BE FIXED
        return;
        if (this.state !== "showBigWin") {
            return;
        }
        this.state = "skp";
        this.bigWin.stop();
        //  this.currentWin = this.skipCount || this.targetWin === 0 ? this.targetWin : this.targetWin - 1;
        this.currentWin = this.skipCount || this.targetWin === 0 ? this.targetWin + 1 : this.targetWin;
        if (!this.skipCount) {
            if (this.currName) {
                Facade.soundManager.stop(this.currName);
            }
            this.currName = `win_big_loop${this.targetWin + 1}`;
            Facade.soundManager.play(this.currName, 1, true, "default");
            console.log("skip bigOut  ", this.bigOut);
            if (this.targetWin === 0) {
                this.bigWin.start(this.bigOut.animations, this.bigOut.count);
            } else {
                this.bigWin.start(this.wins[this.targetWin].animations, [1, 1, 1]);
            }
            Signals.skipCountingUpWinnings.dispatch();
        } else {
            this.reset();
            this.containerBigWin.visible = true;
            gsap.to(this.containerBigWin, {duration: 1, alpha: 0, ease: "back.inOut(0.4)"});
            // this.bigWin.alpha = 0
            this.currentWin = 0;
            this.targetWin = 0;
            this.onComplete();
        }
        this.skipCount = true;
    }

    onComplete = () => {
        this.state = "finish";
        Facade.model.clearBigWin()
        Signals.showBigWinComplete.dispatch()
        Signals.hideCountingUpWinnings.dispatch();
    };

    onOrientationChanged(orientationSymbol) {
    }
}
